import React from "react";
import Modal from "../Modal/Modal";
import styles from "./AddJobLogsModal.module.scss";
import { AddJobLogsType } from "../../Pages/Admin/AddJobLogs/AddJobLogs";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedRowData: AddJobLogsType | null;
}

function AddJobLogsModal(props: Props) {
  const { isOpen, setIsOpen, selectedRowData } = props;
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={styles.mainContainer}>
        <div className={styles.headingContainer}>
          <h1 className={styles.heading}>Add Job Log</h1>
          <button className={styles.button}>Regenerate</button>
        </div>
        <div className={styles.contentContainer}>
          {selectedRowData &&
            Object.keys(selectedRowData as AddJobLogsType).map((key, i) => {
              const typedKey = key as keyof AddJobLogsType;
              if (typedKey === "provenJobResponse") {
                const prettyJson = JSON.stringify(
                  selectedRowData?.[typedKey],
                  null,
                  2
                );
                return (
                  <div className={styles.contentItem} key={i}>
                    <h2 className={styles.contentItemHeading}>{typedKey}</h2>
                    <pre className={styles.contentItemValue}>{prettyJson}</pre>
                  </div>
                );
              }
              return (
                <div className={styles.contentItem} key={i}>
                  <h2 className={styles.contentItemHeading}>{typedKey}</h2>
                  <p className={styles.contentItemValue}>
                    {selectedRowData?.[typedKey]}
                  </p>
                </div>
              );
            })}
        </div>
      </div>
    </Modal>
  );
}

export default AddJobLogsModal;
